/**
 * Normalise les espaces d'un prénom/nom : trim + collapse des espaces multiples
 * (espace, tab, NBSP, etc.) en un seul espace. Sortie en Unicode NFC stable.
 *
 * À appliquer avant d'envoyer un nom/prénom à l'API : YouSign v3 rejette les
 * espaces en début/fin et les espaces multiples sur info.first_name/last_name.
 */
export function normalizeNameSpaces(name: string | null | undefined): string {
  if (!name) return '';
  return name.normalize('NFC').replace(/\s+/g, ' ').trim();
}
